import React from 'react';
import styles from './messagePanel.module.css';
import { X } from 'lucide-react';

export default function MessagePanel({
  activeMessageTransaction,
  setActiveMessageTransaction,
  messageThread,
  newMessage,
  setNewMessage,
  sendMessage,
  mockData
}) {
  if (!activeMessageTransaction) return null;

  return (
    <div className={styles.messagePanel}>
      {/* Panel Header */}
      <div className={styles.messagePanelHeader}>
        <div className={styles.messagePanelTitle}>
          {activeMessageTransaction.recordType === 'inventory' && 'Internal Notes - Inventory'}
          {activeMessageTransaction.recordType === 'customer' && 'Internal Notes - Customer'}
          {activeMessageTransaction.recordType === 'glAccount' && 'Internal Notes - GL Account'}
          {!activeMessageTransaction.recordType && 'Internal Notes'}
        </div>
        <button
          onClick={() => setActiveMessageTransaction(null)}
          className={styles.messagePanelCloseButton}
        >
          <X className={styles.messagePanelCloseIcon} />
        </button>
      </div>
      {/* Message Thread */}
      <div className={styles.messageThread}>
        <div className={styles.messageThreadContent}>
          {messageThread.map((msg) => (
            <div
              key={msg.id}
              className={msg.sender === 'bookkeeper'
                ? styles.messageBubbleBookkeeper
                : styles.messageBubbleClient}
            >
              <div className={styles.messageHeader}>
                <span className={styles.messageSender}>
                  {msg.sender === 'bookkeeper' ? 'You' : (msg.isInternal ? 'Internal' : 'Team Member')}
                </span>
                <span className={styles.messageTimestamp}>{msg.timestamp}</span>
              </div>
              <p className={styles.messageText}>{msg.message}</p>
            </div>
          ))}
        </div>
      </div>
      {/* Message Input */}
      <div className={styles.messageInputContainer}>
        {/* Quick Templates */}
        <div className={styles.quickTemplates}>
          <label className={styles.quickTemplatesLabel}>Internal Note Templates</label>
          <select
            onChange={(e) => setNewMessage(e.target.value)}
            className={styles.quickTemplatesSelect}
          >
            <option value="">Select template...</option>
            <option value="Need to follow up on this transaction">Need to follow up on this transaction</option>
            <option value="Waiting for additional documentation">Waiting for additional documentation</option>
            <option value="Requires manager review">Requires manager review</option>
            <option value="Potential duplicate - need to investigate">Potential duplicate - need to investigate</option>
            <option value="Classification needs verification">Classification needs verification</option>
          </select>
        </div>
        {/* Message Input */}
        <div className={styles.messageInputWrapper}>
          <textarea
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            placeholder="Add an internal note..."
            className={styles.messageTextarea}
            rows={4}
          />
          <div className={styles.messageInputActions}>
            <div className={styles.internalNoteInfo}>
              <span className={styles.internalNoteText}>Internal notes are not shared with clients</span>
            </div>
            <div className={styles.messageInputButtons}>
              <button
                onClick={sendMessage}
                className={styles.sendMessageButton}
              >
                Add Note
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
